import React from "react";
import { Wrapper, Inner, Text, Spinner } from "./styles/sending-styles";
import spinner from "./img/loading.gif";

const Sending = () => (
  <Wrapper>
    <Inner>
      <Spinner src={spinner} alt="Sending spinner" />
      <Text>Sending...</Text>
    </Inner>
  </Wrapper>
);

export default Sending;
